export default __webpack_public_path__ + "static/media/akun-list.1b6bdefe.png";